export default "__VITE_ASSET__85b98ceb__"